import { useQuery } from 'react-query';
import { createRenewalEligibilityEndpoint } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';

type RenewalEligibilityResponse = {
  eligible: boolean;
  reasons?: string[];
};

const RENEWAL_ELIGIBILITY_QUERY_KEY = [
  'journey-api',
  'renewal',
  'eligibility',
] as const;

function useRenewalEligibilityQuery(accountId?: string | null) {
  return useQuery({
    queryFn: () =>
      apiService.get<RenewalEligibilityResponse>({
        url: createRenewalEligibilityEndpoint(accountId as string),
        headers: { 'x-ovo-client': 'gemini' },
      }),
    queryKey: [...RENEWAL_ELIGIBILITY_QUERY_KEY, accountId],
    enabled: Boolean(accountId),
  });
}

export { RENEWAL_ELIGIBILITY_QUERY_KEY, useRenewalEligibilityQuery };
